module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kjHYw"))).then(() => parcelRequire('d0iPb'));